<template>
  <div class="menu-row" :class="{ muted: muted || isSoldOut, 'sold-out': isSoldOut }">
    <span class="row-name">{{ name }}</span>
    <span class="row-dots"></span>
    <span class="row-price">
      <span v-if="isSoldOut" class="sold-out-badge">Agotado</span>
      <template v-else>{{ finalPrice }}</template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'MenuRow',
  props: {
    name: { type: String, required: true },
    price: { default: null },
    priceLabel: { type: String, default: '' },
    muted: { type: Boolean, default: false },
    status: { type: String, default: 'visible' },
  },
  computed: {
    isSoldOut() {
      return this.status === 'sold_out'
    },
    finalPrice() {
      if (this.priceLabel) return this.priceLabel
      if (this.price === null || this.price === undefined || this.price === '') return '-'

      const number = Number(this.price)
      if (Number.isNaN(number)) return this.price

      return `$${number.toFixed(number % 1 === 0 ? 0 : 2)}`
    }
  }
}
</script>

<style scoped>
.menu-row {
  display: grid;
  grid-template-columns: minmax(0, max-content) minmax(18px, 1fr) max-content;
  align-items: baseline;
  gap: 10px;
  font-size: clamp(16px, .95vh, 18px);
  line-height: 1.2;
  color: var(--afro-ink);
}

.row-name {
  min-width: 0;
  white-space: nowrap;
}

.row-dots {
  min-width: 18px;
  border-bottom: 2px dotted rgba(33, 30, 23, .38);
  transform: translateY(-4px);
}

.row-price {
  min-width: 48px;
  text-align: right;
  font-weight: 800;
  color: var(--afro-olive);
  font-variant-numeric: tabular-nums;
}

.menu-row.muted .row-price {
  color: rgba(23, 18, 13, .45);
}

.menu-row.sold-out .row-name,
.menu-row.sold-out .row-dots { opacity: .52; }

.sold-out-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 21px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #b95f57;
  color: #fff8ef;
  font-family: var(--afro-text-sans);
  font-size: .68em;
  font-weight: 900;
  line-height: 1;
  letter-spacing: .03em;
  text-transform: uppercase;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .menu-row {
    grid-template-columns: minmax(0, auto) minmax(18px, 1fr) max-content;
    font-size: 15px;
  }

  .row-name {
    white-space: normal;
  }
}
</style>
